import React, { Component, Fragment } from "react";
import CollapseMenu from "../../../../config/atoms/CollapseMenu";
import MenuDetail from "../MenuDetail";
import { rekapPresensiMahasiswa } from "../../../../dummy-data/presensi";
import { dataMahasiswa } from "../../../../dummy-data/mahasiswa";
import { dataKRS } from "../../../../dummy-data/krs-khs";

class Presensi extends Component {
    state = {
        user: [],
        listSemester: [],
        listPresensi: [],
        isLoading: false,

        // params
        idVal: '',
        nimVal: ''
    }

    getAllData = () => {
        const nim = this.state.nimVal;
        const mhs = dataMahasiswa.find(m => m.nim === nim);

        // Get semesters from KRS data
        const krsData = dataKRS.filter(k => k.nim === nim);
        const semesters = [...new Set(krsData.map(k => k.semester_ke))].sort((a, b) => a - b);

        this.setState({
            user: {
                angkatan: mhs ? mhs.angkatan : '2020',
                jurusan: mhs ? mhs.prodi : 'Teknik Informatika',
                nama: mhs ? mhs.nama : 'Mahasiswa Demo',
                nim: nim,
                kurikulum: '2020'
            },
            listSemester: semesters.length > 0 ? semesters.map(s => ({ semester: s })) : [{ semester: 7 }]
        });
    }

    inputSemester = (e) => {
        this.setState({ isLoading: true });

        const nim = this.state.nimVal;
        const rekap = rekapPresensiMahasiswa.find(r => r.nim === nim);

        setTimeout(() => {
            if (rekap) {
                const presensiData = rekap.rekap.map(r => ({
                    kodemk: `MK${r.jadwal_id}`,
                    matakuliah: r.nama_mk,
                    sks: 3,
                    dosen: 'Dosen Demo',
                    hadir: r.hadir,
                    alpa: r.alpha,
                    sakit: 0,
                    ijin: r.izin,
                    total_pertemuan: r.total_pertemuan
                }));
                this.setState({ listPresensi: presensiData, isLoading: false });
            } else {
                this.setState({ listPresensi: [], isLoading: false });
            }
        }, 300);
    }

    setParams = () => {
        const queryParams = new URLSearchParams(window.location.search);
        this.setState({
            idVal: queryParams.get('id'),
            nimVal: queryParams.get('nim')
        }, () => {
            this.getAllData()
        })
    }

    componentDidMount = () => {
        document.getElementById("presensiMenu").classList.add("active");
        CollapseMenu();
        this.setParams()
    };
    render() {
        return (
            <div>
                <Fragment>
                    <div className="col-md-12 mb-3">
                        <div className="row">
                            <div className="col-12 col-xl-8 mb-xl-0">
                                <p
                                    className="abu"
                                    style={{
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        color: "#999999",
                                        textTransform: "capitalize",
                                    }}
                                >
                                    Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Data
                                    Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp; Presensi
                                </p>
                            </div>
                            <div className="col-12 col-xl-4 sm-md-none">
                                <div className="justify-content-end d-flex ">
                                    <div
                                        style={{ cursor: "pointer" }}
                                        title="expand/minimize"
                                        id="toogleMenu"
                                    >
                                        <i className="fa fa-expand abu" id="iconQ"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" id="smoothMain">
                        <div className="col-xl-3 order-xl-2 smoothTabs" id="menuKanan">
                            <MenuDetail id={this.state.idVal} nim={this.state.nimVal} />
                        </div>

                        <div className="col-xl-9" id="kontenKiri">
                            <div className="card card-custom">
                                <div className="card-body">
                                    <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                                        Presensi
                                    </p>
                                    <div className="table-responsive pl-2 pr-2">
                                        <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                            <thead></thead>
                                            <tbody>
                                                <tr>
                                                    <td>NIM</td>
                                                    <td> : </td>
                                                    <td>{this.state.user.nim}</td>

                                                    <td>Angkatan</td>
                                                    <td> : </td>
                                                    <td>{this.state.user.angkatan}</td>
                                                </tr>
                                                <tr>
                                                    <td>Nama</td>
                                                    <td> : </td>
                                                    <td>{this.state.user.nama}</td>

                                                    <td>Semester</td>
                                                    <td> : </td>
                                                    <td>
                                                        <select className="form-control" name="semester" onChange={this.inputSemester}>
                                                            <option value="">- Pilih Semester -</option>
                                                            {this.state.listSemester.map((v, index) => {
                                                                return (
                                                                    <option key={index} value={v.semester}>{'Semester ' + v.semester}</option>
                                                                )
                                                            })
                                                            }
                                                        </select>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <br />
                                    <br />
                                    <p className="card-title" style={{ fontSize: "17px", marginLeft: "10px" }}>
                                        Laporan Presensi Mahasiswa :
                                    </p>
                                    {this.state.isLoading ?
                                        <div id="loaderMhs">
                                            <div className="loader-1 colorful mt-5 mb-2">
                                                <div className="dot" />
                                                <div className="dot" />
                                                <div className="dot" />
                                            </div>
                                            <p align="center" className="mb-5">loading data...</p>
                                        </div>
                                        :
                                        <div className="table-responsive pl-2 pr-2 mt-3">
                                            <table className="table-bordered" style={{ width: "100%" }}>
                                                <tbody>
                                                    <tr className='customTable'>
                                                        <td width="50px" rowSpan={2} align='center'>
                                                            No
                                                        </td>
                                                        <td width="120px" rowSpan={2} align='center'>
                                                            Kode MK
                                                        </td>
                                                        <td width="300px" rowSpan={2} align='center'>
                                                            MK
                                                        </td>
                                                        <td width="50px" rowSpan={2} align='center'>
                                                            SKS
                                                        </td>
                                                        <td width="300px" rowSpan={2} align='center'>
                                                            Dosen
                                                        </td>
                                                        <td height="40px" width="300px" colSpan={5} align='center'>
                                                            Keterangan
                                                        </td>
                                                    </tr>
                                                    <tr className='customTable'>
                                                        <td width="60px" align="center">
                                                            Hadir
                                                        </td>
                                                        <td height="40px" width="60px" align="center">
                                                            Alpa
                                                        </td>
                                                        <td height="40px" width="60px" align="center">
                                                            Sakit
                                                        </td>
                                                        <td height="40px" width="60px" align="center">
                                                            Ijin
                                                        </td>
                                                        <td height="40px" width="60px" align="center">
                                                            Total
                                                        </td>
                                                    </tr>
                                                    {this.state.listPresensi.length == 0 ?
                                                        <tr>
                                                            <td colSpan={10} style={{ padding: '20px', textAlign: 'center' }}>Tidak Ada Data.</td>
                                                        </tr>
                                                        :
                                                        <Fragment>
                                                            {this.state.listPresensi.map((list, i) => {
                                                                return (
                                                                    <tr className='customTable2' key={i}>
                                                                        <td height="40px" align="center">{i + 1}</td>
                                                                        <td height="40px" align="center">{list.kodemk}</td>
                                                                        <td height="40px" align="center">{list.matakuliah}</td>
                                                                        <td height="40px" align="center">{list.sks}</td>
                                                                        <td height="40px" align="center">{list.dosen}</td>
                                                                        <td height="40px" align="center">{list.hadir}</td>
                                                                        <td height="40px" align="center">{list.alpa}</td>
                                                                        <td height="40px" align="center">{list.sakit}</td>
                                                                        <td height="40px" align="center">{list.ijin}</td>
                                                                        <td height="40px" align="center">{list.total_pertemuan}</td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </Fragment>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    }
                                    <br />
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment >
            </div >
        );
    }
}

export default Presensi;
